const TOKEN_KEY = process.env.REACT_APP_USER_TOKEN || 'token';

// Read sessionStorage first (session login), then fallback to localStorage (remember me)
export const getToken = () =>
  sessionStorage.getItem(TOKEN_KEY) ?? localStorage.getItem(TOKEN_KEY);

// Persist with choice
export const setSessionToken = (token) => {
  if (token == null) return;
  sessionStorage.setItem(TOKEN_KEY, token);
};
export const setLocalToken = (token) => {
  if (token == null) return;
  localStorage.setItem(TOKEN_KEY, token);
};

// Remove everywhere
export const removeToken = () => {
  try { sessionStorage.removeItem(TOKEN_KEY); } catch {}
  try { localStorage.removeItem(TOKEN_KEY); } catch {}
};